
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" id="Layer_1" x="0" y="0" style="enable-background:new 0 0 640 480" version="1.1" viewBox="50 50 480 480"><path d="m140.4 312.2 161.5 102.9 161.5-102.9-161.5-103z" class="st0"/><path d="m140.4 179.3 161.5 102.9 161.5-102.9L301.9 76.4z" class="st1"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    